import { skipToken, useQuery } from '@tanstack/react-query';

import { type GetFriendsAndFamilyUsageQuery, getFriendsAndFamilyUsage } from '~/services/PromoService';

export const friendsAndFamilyUsageQueryKeys = {
  all: ['friends-and-family-usage'] as const,
  detail: (query: GetFriendsAndFamilyUsageQuery) => [...friendsAndFamilyUsageQueryKeys.all, query] as const,
};

export function useGetFriendsAndFamilyUsage(query: GetFriendsAndFamilyUsageQuery | null) {
  return useQuery({
    queryKey: query ? friendsAndFamilyUsageQueryKeys.detail(query) : friendsAndFamilyUsageQueryKeys.all,
    queryFn: query ? ({ signal }) => getFriendsAndFamilyUsage(query, { signal }) : skipToken,
    enabled: query !== null,
  });
}
